// Services.js
import React from 'react';
import ServiceCard from '../components/services/ServiceCard/ServiceCard';
import Button from '../components/common/Button/Button';
import styles from './Services.module.css'; // This will contain styles for this page and its header

function Services() {
  const services = [
    {
      title: "Construction de Maisons à Ossature Bois",
      description: "Faites le choix d'une maison saine, performante et économe en énergie. La maison à ossature bois offre une isolation thermique et phonique exceptionnelle, une rapidité de construction et une grande liberté architecturale.",
      imageSrc: "/images/maison.jpg",
      features: [
        "Conception sur mesure de votre projet",
        "Performance énergétique RT2012/RE2020",
        "Matériaux écologiques et durables",
        "Rapidité d'exécution et chantier propre"
      ]
    },
    {
      title: "Extensions et Surélévations Bois",
      description: "Besoin d'agrandir votre espace de vie sans déménager ? L'extension ou la surélévation en bois est la solution idéale. Rapide à mettre en œuvre, légère et peu contraignante pour la structure existante, elle s'intègre harmonieusement à votre habitat, qu'il soit traditionnel ou moderne.",
      imageSrc: "/images/extension1.jpg",
      features: [
        "Augmentation de la surface habitable",
        "Valorisation de votre patrimoine",
        "Intégration architecturale soignée",
        "Chantier minimalement invasif"
      ]
    },
    {
      title: "Aménagements Extérieurs : Terrasses, Pergolas et Carports",
      description: "Prolongez votre intérieur vers l'extérieur avec nos aménagements bois sur mesure. Créez des espaces de convivialité, d'ombre ou de protection pour vos véhicules, conçus pour s'intégrer parfaitement à votre environnement.",
      imageSrc: "/images/terrasse1.jpg",
      features: [
        "Terrasses en bois composite ou naturel",
        "Pergolas et carports sur mesure",
        "Design intégré à votre jardin",
        "Durabilité et résistance aux intempéries"
      ]
    },
    {
      title: "Bâtiments Professionnels & Commerciaux",
      description: "Des locaux adaptés à votre activité, construits rapidement grâce à la préfabrication en ossature bois. Offrez à vos équipes et clients un espace de travail chaleureux, économique et respectueux de l'environnement, reflétant les valeurs de votre entreprise.",
      imageSrc: "/images/maison2.jpg",
      features: [
        "Temps de construction optimisé",
        "Espaces de travail modulables",
        "Excellente performance énergétique",
        "Image de marque éco-responsable"
      ]
    },
    {
      title: "Bâtiments Agricoles & Équestres",
      description: "Conception et réalisation de structures en bois robustes et pérennes adaptées aux exigences du monde agricole. Le bois offre une excellente résistance mécanique, régule naturellement l'humidité et s'intègre parfaitement dans nos campagnes.",
      imageSrc: "/images/maison3.jpg",
      features: [
        "Charpentes traditionnelles de grande portée",
        "Bonne régulation hygrométrique et thermique",
        "Intégration paysagère naturelle",
        "Solidité et résistance aux environnements agressifs"
      ]
    },
    {
      title: "Bureau d'Étude & Conception 3D",
      description: "Au-delà de la construction, notre bureau d'étude intégré vous accompagne de la toute première idée jusqu'aux plans d'exécution définitifs. La modélisation 3D, l'optimisation de la structure et la gestion des démarches administratives garantissent une réalisation sereine et sans surprise.",
      imageSrc: "/images/plan_service.jpg",
      features: [
        "Réalisation de plans personnalisés et modélisation 3D",
        "Optimisation technique, architecturale et financière",
        "Prise en charge du dépôt de permis de construire",
        "Étude et parfaite conformité aux normes environnementales"
      ]
    }
  ];

  return (
    <> {/* Utilisation d'un Fragment React pour englober la section d'en-tête et le contenu principal */}
      {/* HEADER MODERNE AVEC IMAGE LOGO.JPG */}
      <section className={styles.pageHeader} style={{ backgroundImage: `url('/images/maison.jpg')` }}>
        <div className={styles.pageHeaderContent}>
          <h1>Nos Prestations</h1>
          <p>L'expertise du bois pour tous vos projets de construction et d'aménagement.</p>
        </div>
      </section>

      {/* Contenu principal de la page Services */}
      <section className="section">
        <div className="container">
          <div className={styles.introSection}>
            <div className={styles.introContent}>
              <div className={styles.introImageWrapper}>
                <div className={styles.imageCard}>
                  <img src="/images/pergola.jpg" alt="Notre expertise bois" className={styles.mainImage} />
                  <div className={styles.qualityBadge}>
                    <span className={styles.badgeLabel}>Excellence</span>
                    <span className={styles.badgeText}>Garantie</span>
                  </div>
                </div>
                <div className={styles.imageDecoration}></div>
              </div>

              <div className={styles.introText}>
                <span className={styles.eyebrow}>Notre Mission</span>
                <h2 className={styles.title}>Notre Savoir-Faire à Votre Service</h2>
                <div className={styles.divider}></div>
                <p className={styles.description}>
                  Chez Maison Quinard, nous maîtrisons l'art de la construction bois sous toutes ses formes. Notre approche combine expertise technique et personnalisation pour faire de chaque projet une réussite.
                </p>
                <div className={styles.highlightNotice}>
                  <p>Découvrez comment notre passion pour le bois et notre exigence de qualité peuvent donner vie à vos ambitions les plus précieuses.</p>
                </div>
              </div>
            </div>
          </div>


          <div className={styles.detailedServices}>
            {services.map((service, index) => (
              <div key={index} className={`${styles.serviceItem} ${index % 2 !== 0 ? styles.reverse : ''}`}>
                <div className={styles.serviceImageWrapper}>
                  <div className={styles.serviceImageCard}>
                    <img src={service.imageSrc} alt={service.title} className={styles.serviceMainImage} />
                    <div className={styles.serviceBadge}>
                      <span className={styles.badgeLabel}>Expertise</span>
                      <span className={styles.badgeText}>Maison Quinard</span>
                    </div>
                  </div>
                  <div className={styles.serviceImageDecoration}></div>
                </div>

                <div className={styles.serviceText}>
                  <span className={styles.serviceNumber}>0{index + 1}</span>
                  <h3 className={styles.serviceTitle}>{service.title}</h3>
                  <div className={styles.serviceDivider}></div>
                  <p className={styles.serviceDescription}>{service.description}</p>

                  <ul className={styles.premiumFeatures}>
                    {service.features.map((feature, fIndex) => (
                      <li key={fIndex}>
                        <span className={styles.checkIcon}>✓</span>
                        {feature}
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            ))}
          </div>


          <div className={styles.contactAction}>
            <div className={styles.actionContent}>
              <span className={styles.actionEyebrow}>Votre Projet Bois</span>
              <h3 className={styles.actionTitle}>Un projet spécifique en tête ?</h3>
              <div className={styles.actionDivider}></div>
              <p className={styles.actionDescription}>N'hésitez pas à nous contacter pour discuter de vos besoins et obtenir une étude personnalisée.</p>
              <div className={styles.actionButtonWrapper}>
                <Button to="/contact" variant="primary" size="large">Demander un devis</Button>
              </div>
            </div>
            <div className={styles.actionDecoration}></div>
          </div>

        </div>
      </section>
    </>
  );
}

export default Services;
